import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTablet: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="tablet, ipad, mobile"><path d="M4.75 2.75H19.25V21.25H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.75 18.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTablet;
